// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1-CoT","content":"styles_content__7AxPM","selectAll":"styles_selectAll__1DLRM"};